<template>
    <div class="container full-width">
        <template>
            <div class="text-subtitle1">Choose schedule</div>
        </template>
    </div>
</template>

<script>
export default {
    name: "Schedule",
};
</script>

<style scoped>
.container {
    padding: 0px 8px;
}
</style>
